import checkmateService from './checkmate'

export const isDevelopment = (): boolean => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
}

export const getApiUrl = (): string => {
  if (isDevelopment()) {
    const envApiUrl = import.meta.env.VITE_API_URL
    if (envApiUrl && envApiUrl !== '/apps/edge-rcm/be') {
      return envApiUrl
    }
  }

  if (checkmateService.isCheckmated()) {
    const checkmateApiUrl = document.documentElement.getAttribute('checkmate-api-url')
    if (checkmateApiUrl) {
      return checkmateApiUrl.startsWith('http') ? checkmateApiUrl : `https://${checkmateApiUrl}`
    }
  }

  const apiUrl = document.documentElement.getAttribute('api-url')
  if (apiUrl) {
    return apiUrl.startsWith('http') ? apiUrl : `https://${apiUrl}`
  }

  return import.meta.env.VITE_API_URL || '/apps/edge-rcm/be'
}

export const getCdnUrl = (pathnameOverride?: string): string => {
  if (isDevelopment()) {
    return import.meta.env.VITE_UI_URL || ''
  }

  const cdnUrl = document.documentElement.getAttribute('cdn-url')

  // If cdn-url attribute exists and is not the placeholder, use it
  if (cdnUrl && cdnUrl !== 'cdn_domain_placeholder') {
    return cdnUrl
  }

  // Fallback: derive CDN URL from current window location
  // This handles cases where the placeholder wasn't replaced during deployment
  // Example: https://cdn.example.com/path/to/app/index.html -> https://cdn.example.com/path/to/app/
  const pathname = pathnameOverride ?? window.location.pathname
  const origin = window.location.origin

  // If we're at root or just /index.html, use origin
  if (pathname === '/' || pathname === '/index.html') {
    return origin + '/'
  }

  // Extract base path (everything up to and including the last directory)
  // /some/path/to/app/index.html -> /some/path/to/app/
  // /some/path/to/app/ -> /some/path/to/app/
  const lastSlashIndex = pathname?.lastIndexOf('/')
  const basePath = lastSlashIndex >= 0 ? pathname.substring(0, lastSlashIndex + 1) : '/'

  return `${origin}${basePath}`
}

export const isCheckmated = (): boolean => {
  const global = globalThis as { MUI?: unknown }
  return typeof global.MUI !== 'undefined' && !!global.MUI
}
